// ------------------- ACTION TYPES -------------------
export const SET_UPLOAD_FORM_FIELD = 'SET_UPLOAD_FORM_FIELD';
export const SET_UPLOAD_FIELD_ERROR = 'SET_UPLOAD_FIELD_ERROR';
export const CLEAR_UPLOAD_FORM = 'CLEAR_UPLOAD_FORM';
export const UPLOAD_SOFTWARE_REQUEST = 'UPLOAD_SOFTWARE_REQUEST';
export const UPLOAD_SOFTWARE_SUCCESS = 'UPLOAD_SOFTWARE_SUCCESS';
export const UPLOAD_SOFTWARE_FAILURE = 'UPLOAD_SOFTWARE_FAILURE';
export const CLEAR_UPLOAD_ALERTS = 'CLEAR_UPLOAD_ALERTS';
export const TRACK_UPLOAD_PROGRESS = 'TRACK_UPLOAD_PROGRESS';
export const UPLOAD_STARTED = 'UPLOAD_STARTED';
export const UPLOAD_STATUS_SUCCESS = 'SUCCESS';

export const FETCH_DATALAKE_DETAILS_REQUEST = 'FETCH_DATALAKE_DETAILS_REQUEST';
export const FETCH_DATALAKE_DETAILS_SUCCESS = 'FETCH_DATALAKE_DETAILS_SUCCESS';
export const FETCH_DATALAKE_DETAILS_FAILURE = 'FETCH_DATALAKE_DETAILS_FAILURE';

// ------------------- VALIDATION REGEX -------------------
export const ITEM_REF_PATTERN = /^[a-zA-Z0-9._-]{0,30}$/;
export const NAME_VERSION_MOD_PATTERN = /^[a-zA-Z0-9._\-\s&]+$/; // Updated to allow spaces and ampersand
export const SAFE_DESCRIPTION_PATTERN = /^[^<>'"();{}\\/]*$/;

// ------------------- GENERIC ERROR MESSAGES -------------------
export const REQUIRED_FIELD_ERR_MSG = "This field is required.";
export const ALPHANUMERIC_VALIDATION_MSG = "Only letters, numbers, spaces, '.', '_', '&' and '-' are allowed.";
export const ACCESS_DENIED_MSG = "Access denied. Please check permissions.";
export const SERVER_ERROR_MSG = "Server error occurred. Try again later.";
export const UNKNOWN_ERROR_MSG = "An unknown error occurred.";
export const FETCH_FAILED_MSG = "Failed to fetch data.";

// ------------------- SPECIFIC VALIDATION MESSAGES -------------------
export const INVALID_PRODUCT_LINE_MSG = `Invalid Product Line. ${ALPHANUMERIC_VALIDATION_MSG}`;
export const INVALID_ITEM_REF_NUMBER_MSG = `Invalid Item/Ref Number. ${ALPHANUMERIC_VALIDATION_MSG}`;
export const INVALID_INSTRUMENT_MODEL_MSG = `Invalid Instrument Model. ${ALPHANUMERIC_VALIDATION_MSG}`;
export const INVALID_SOFTWARE_NAME_MSG = `Invalid Software Name. ${ALPHANUMERIC_VALIDATION_MSG}`;
export const INVALID_SOFTWARE_VERSION_MSG = `Invalid Software Version. ${ALPHANUMERIC_VALIDATION_MSG}`;
export const INVALID_INSTRUMENT_MOD_MSG = `Invalid Mod Id. ${ALPHANUMERIC_VALIDATION_MSG}`;
export const INVALID_SOFTWARE_BRIEF_DESCRIPTION_MSG = "Description contains unsafe characters (like <, >, ', \", ;, (, ), {, }, /, \\). Please remove them.";
export const INVALID_SOFTWARE_SIZE_MSG = "File size exceeds the 10 GB limit.";

// ------------------- SPECIFIC ERROR MESSAGES: UPLOAD -------------------
export const UPLOAD_UNKNOWN_ERROR = `${UNKNOWN_ERROR_MSG} during upload.`;
export const UPLOAD_FILE_NOT_FOUND = "File not found. Please ensure the file exists.";
export const UPLOAD_ACCESS_DENIED = ACCESS_DENIED_MSG;
export const UPLOAD_SERVER_ERROR = `${SERVER_ERROR_MSG} during upload.`;
export const UPLOAD_FAILED_WITH_STATUS = (status) => `Upload failed with status ${status}`;
export const UPLOAD_FAILED_WITH_RESPONSE = (text) => `Upload failed: ${text}`;

// ------------------- SPECIFIC ERROR MESSAGES: DATALAKE -------------------
export const DATALAKE_FETCH_FAILED = `${FETCH_FAILED_MSG} DataLake SAS details.`;
export const DATALAKE_ACCESS_DENIED = `${ACCESS_DENIED_MSG} to DataLake API.`;
export const DATALAKE_NOT_FOUND = "DataLake endpoint not found.";
export const DATALAKE_INTERNAL_ERROR = `Internal ${SERVER_ERROR_MSG.toLowerCase()} fetching SAS URL.`;

// ------------------- SPECIFIC SUCCESS MESSAGES -------------------
export const UPLOAD_SUCCESS_MSG = "File uploaded successfully!";
export const DATALAKE_FETCH_SUCCESS = "SAS URL map retrieved successfully.";

// ------------------- LENGTH LIMITS -------------------
export const ITEM_REF_NUMBER_MAX_LENGTH = 30;
export const INSTRUMENT_MOD_MAX_LENGTH = 30;
export const SOFTWARE_NAME_MAX_LENGTH = 250;
export const SOFTWARE_VERSION_MAX_LENGTH = 20;
export const SOFTWARE_BRIEF_DESCRIPTION_MAX_LENGTH = 500;
export const FILE_SIZE_LIMIT_GB = 10;
export const FILE_SIZE_LIMIT_BYTES = FILE_SIZE_LIMIT_GB * 1024 * 1024 * 1024;

// ------------------- REQUIRED FIELDS -------------------
export const REQUIRED_UPLOAD_FIELDS = [
  'productLine',
  'itemRefNumber',
  'instrumentModel',
  'instrumentMod',
  'softwareName',
  'softwareVersion',
  'packageFile',
];
